<style lang="scss" scoped>
.card {
  background-color: #e9ecef;
}

.sort-icon {
  opacity: 0.5;
  transition: opacity 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}

.split-icon {
  opacity: 0.5;
}
</style>

<template>
  <div class="card mb-0">
    <div
      class="card-body d-flex flex-column align-items-center justify-content-center"
    >
      <i
        class="fas fa-angle-up sort-icon"
        v-if="!first"
        @click="emit('up')"
      ></i>
      <i class="fas fa-minus split-icon"></i>
      <i
        class="fas fa-angle-down sort-icon"
        v-if="!last"
        @click="emit('down')"
      ></i>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    index: {
      type: Number
    },
    first: {
      type: Boolean
    },
    last: {
      type: Boolean
    }
  },
  methods: {
    emit(direction) {
      this.$emit('sort', {
        direction: direction,
        index: this.index
      });
    }
  }
}
</script>
